var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2225 8.25359H2.36914C2.02414 8.25359 1.74414 7.97359 1.74414 7.62859C1.74414 7.28359 2.02414 7.00359 2.36914 7.00359H17.2225C17.5675 7.00359 17.8475 7.28359 17.8475 7.62859C17.8475 7.97359 17.5675 8.25359 17.2225 8.25359Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5014 11.508C13.1564 11.508 12.873 11.228 12.873 10.883C12.873 10.538 13.1489 10.258 13.4939 10.258H13.5014C13.8464 10.258 14.1264 10.538 14.1264 10.883C14.1264 11.228 13.8464 11.508 13.5014 11.508Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80314 11.508C9.45814 11.508 9.1748 11.228 9.1748 10.883C9.1748 10.538 9.45064 10.258 9.79564 10.258H9.80314C10.1481 10.258 10.4281 10.538 10.4281 10.883C10.4281 11.228 10.1481 11.508 9.80314 11.508Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09792 11.508C5.75292 11.508 5.46875 11.228 5.46875 10.883C5.46875 10.538 5.74542 10.258 6.09042 10.258H6.09792C6.44292 10.258 6.72292 10.538 6.72292 10.883C6.72292 11.228 6.44292 11.508 6.09792 11.508Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5014 14.7469C13.1564 14.7469 12.873 14.4669 12.873 14.1219C12.873 13.7769 13.1489 13.4969 13.4939 13.4969H13.5014C13.8464 13.4969 14.1264 13.7769 14.1264 14.1219C14.1264 14.4669 13.8464 14.7469 13.5014 14.7469Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80314 14.7469C9.45814 14.7469 9.1748 14.4669 9.1748 14.1219C9.1748 13.7769 9.45064 13.4969 9.79564 13.4969H9.80314C10.1481 13.4969 10.4281 13.7769 10.4281 14.1219C10.4281 14.4669 10.1481 14.7469 9.80314 14.7469Z",
    fill: "#313131"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09792 14.7469C5.75292 14.7469 5.46875 14.4669 5.46875 14.1219C5.46875 13.7769 5.74542 13.4969 6.09042 13.4969H6.09792C6.44292 13.4969 6.72292 13.7769 6.72292 14.1219C6.72292 14.4669 6.44292 14.7469 6.09792 14.7469Z",
    fill: "#313131"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1611 4.82584C12.8161 4.82584 12.5361 4.54584 12.5361 4.20084V1.45834C12.5361 1.11334 12.8161 0.833336 13.1611 0.833336C13.5061 0.833336 13.7861 1.11334 13.7861 1.45834V4.20084C13.7861 4.54584 13.5061 4.82584 13.1611 4.82584Z",
    fill: "#313131"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.42969 4.82584C6.08469 4.82584 5.80469 4.54584 5.80469 4.20084V1.45834C5.80469 1.11334 6.08469 0.833336 6.42969 0.833336C6.77469 0.833336 7.05469 1.11334 7.05469 1.45834V4.20084C7.05469 4.54584 6.77469 4.82584 6.42969 4.82584Z",
    fill: "#313131"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_358_960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 17,
    height: 17
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 2.14925H17.917V18.75H1.66699V2.14925Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_358_960)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26783 3.39925C4.10699 3.39925 2.91699 4.55175 2.91699 6.64425V14.1851C2.91699 16.3234 4.10699 17.5001 6.26783 17.5001H13.3162C15.477 17.5001 16.667 16.3451 16.667 14.2484V6.64425C16.6703 5.61509 16.3937 4.81509 15.8445 4.26509C15.2795 3.69842 14.4087 3.39925 13.3237 3.39925H6.26783ZM13.3162 18.7501H6.26783C3.43033 18.7501 1.66699 17.0009 1.66699 14.1851V6.64425C1.66699 3.87092 3.43033 2.14925 6.26783 2.14925H13.3237C14.7478 2.14925 15.9253 2.57592 16.7295 3.38175C17.5103 4.16592 17.9212 5.29342 17.917 6.64592V14.2484C17.917 17.0251 16.1537 18.7501 13.3162 18.7501Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.7b76c8ad5550a0b5b0b81fda1917715b.svg";
export { ForwardRef as ReactComponent };